import ResourceService from './resource.service'

class SupplierService extends ResourceService {
  static get resource() {
    return 'provider'
  }
}

export default SupplierService
